import { FunctionComponent } from 'react'
import Image from 'next/image'
import cn from 'classnames'

import { Icon, IconName } from '@/icons'
import { Image as IImage } from '@/services/Api/generated'

import styles from './HeaderTag.module.scss'

type HeaderTagProps = {
  icon?: IconName
  image?: IImage
  title: string
  className?: string
}
export const HeaderTag: FunctionComponent<HeaderTagProps> = ({
  icon,
  image,
  className,
  title,
}) => {
  return (
    <div className={cn(styles.container, className)}>
      <div className={styles.animation}>
        <div className={styles.borderContainer}>
          <div className={styles.border}></div>
          <div className={styles.borderAnimated}></div>
        </div>
      </div>
      <div className={styles.content}>
        {image != null ? (
          <Image
            className={styles.image}
            src={image.url}
            alt=""
            width={image.width}
            height={image.height}
          />
        ) : null}
        {image == null && icon != null ? (
          <Icon name={icon} className={styles.icon} />
        ) : null}
        {title}
      </div>
    </div>
  )
}
